import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Box, CircularProgress, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

import { getAllPodsState } from '../../../../features/pod/get_all_pods';
import { deletePodPriceListAction, deletePodPriceListState } from '../../../../features/price/delete_pod_price_list';
import { deletePodPriceListNotificationData } from '../../../../core/utils/notification_utils';
import useNotification from '../../../../core/hooks/use_notification';
import { ApiRequestStatusEnum } from '../../../../core/enums/common/api';

const PodsList = ({ podIds, refreshPriceList }) => {
    const dispatch = useDispatch();
    const { showNotification } = useNotification();

    const getAllPods = useSelector(getAllPodsState);
    const deletePodPriceList = useSelector(deletePodPriceListState);

    const onRemovePod = (podId) => {
        dispatch(deletePodPriceListAction(podId))
            .then(response => {
                showNotification(deletePodPriceListNotificationData(response));
                response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED && refreshPriceList();
            });
    };

    return (
        <Box>
            <TableContainer component={ Paper } variant="outlined">
                <Table stickyHeader>
                    <TableHead>
                        <TableRow sx={ { '& th': { backgroundColor: 'slate.50', fontWeight: 600 } } }>
                            <TableCell>Partner</TableCell>
                            <TableCell>Urządzenie</TableCell>
                            <TableCell>Opis</TableCell>
                            <TableCell>Adres</TableCell>
                            <TableCell align="center">Typ</TableCell>
                            <TableCell align="center" sx={ { width: 100 } }></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            podIds?.map(podId => {
                                const pod = getAllPods?.data?.find(p => p.id === podId);

                                if (!pod) return null;

                                return (
                                    <TableRow key={ pod.id } hover>
                                        <TableCell>{ pod?.indoorPartner?.name }</TableCell>
                                        <TableCell>{ pod?.device?.serviceId || '-' }</TableCell>
                                        <TableCell>{ pod?.description }</TableCell>
                                        <TableCell>{ pod?.address }</TableCell>
                                        <TableCell align="center">{ pod?.locationType }</TableCell>
                                        <TableCell align="center">
                                            <Tooltip title="Usuń cennik">
                                                <IconButton
                                                    onClick={ () => onRemovePod(pod.id) }
                                                    disabled={ deletePodPriceList?.loading }
                                                >
                                                    {
                                                        deletePodPriceList?.loading
                                                            ? <CircularProgress size={ 20 } color="inherit"/>
                                                            : <RemoveCircleIcon/>
                                                    }
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                );
                            })
                        }
                        { (!podIds || podIds.length === 0) && (
                            <TableRow>
                                <TableCell colSpan={ 6 } align="center"
                                           sx={ { py: 4, color: 'text.secondary' } }>
                                    Brak wyników do wyświetlenia.
                                </TableCell>
                            </TableRow>
                        ) }
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default PodsList;